import TextComponent from '@/components/TextComponent';
import theme from '@/styles/theme';
import styled from 'styled-components';

interface Props {
  onClickResetOrder: () => void;
  onSubmitPickupCall: () => void;
}
const PartnershipPickup = ({
  onClickResetOrder,
  onSubmitPickupCall
}: Props) => {
  return (
    <Wrapper>
      <Row>
        <TextComponent
          fontSize={18}
          color={theme.DF_COLOR.GRAY700}
          style={{ paddingBottom: 24 }}>
          약을 다 조제하셨나요?
          <br />
          픽업 요청을 누르면 자동으로 환자에게 안내 메시지가 보내져요.
        </TextComponent>
      </Row>
      <Row>
        <ReadyStatus>
          <Button
            style={{ flex: 0.5 }}
            background={theme.DF_COLOR.WHITE}
            borderColor={theme.DF_COLOR.GRAY100}
            onClick={onClickResetOrder}>
            <ButtonText color={theme.DF_COLOR.BLACK}>조제 접수 초기화</ButtonText>
          </Button>
          <Button
            style={{ flex: 0.5 }}
            background={theme.DF_COLOR.PRIMARY600}
            borderColor={theme.DF_COLOR.PRIMARY600}
            onClick={onSubmitPickupCall}>
            <ButtonText color={theme.DF_COLOR.WHITE}>픽업 요청</ButtonText>
          </Button>
        </ReadyStatus>
      </Row>
    </Wrapper>
  );
};

export default PartnershipPickup;

const Wrapper = styled.div`
  flex: 1;
`;

const ReadyStatus = styled.div`
  display: flex;
  flex-flow: row;
  width: 100%;
`;

const Button = styled.button<{ background: string; borderColor: string }>`
  display: flex;
  background: ${({ background }) => background};
  border: ${({ borderColor }) => `1px solid ${borderColor}`};
  padding: 14px 35px;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-right: 8px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  :disabled {
    opacity: 0.5;
  }
`;

const ButtonText = styled(TextComponent)<{ color: string }>`
  font-size: 17px;
  font-weight: 500;
  color: ${({ color }) => color};
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;
